import { Component, Input, OnInit } from '@angular/core';
import * as MenuActions from '@states/menu/menu.actions';
import { MenuKey } from '@enums/menu.enum';
import { select, Store } from '@ngrx/store';
import { UntypedFormGroup } from '@angular/forms';
import { LocationEditSelectors } from '@states/location-edit/location-edit.selector-types';
import { DeviceModel } from '@models/device.model';
import { LocationEditActions } from '@states/location-edit/location-edit.action-types';
import { ActivatedRoute, Router } from '@angular/router';
import { routerSegments } from '@consts/routes';
import { Dictionary } from '@ngrx/entity/src/models';
import { MatDialog } from '@angular/material/dialog';
import * as _ from 'lodash';
import { UtilsV2Service } from '../../../services/utils-v2.service';
import { CameraPickerModels } from '../../../modals/camera-picker-inline/models/models';
import { CameraPickerModalComponent } from '../../../modals/camera-picker-modal/camera-picker-modal.component';
import { UiKitModule } from '../../../shared/ui-kit/ui-kit.module';
import { TranslatePipe } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltip } from '@angular/material/tooltip';

import DeviceType = DeviceModel.DeviceType;

@Component({
  selector: 'app-location-speakers',
  templateUrl: './location-speakers.component.html',
  styleUrls: ['./location-speakers.component.scss'],
  imports: [
    UiKitModule,
    TranslatePipe,
    UiKitModule,
    TranslatePipe,
    MatTableModule,
    MatSortModule,
    MatTooltip,
  ],
})
export class LocationSpeakersComponent implements OnInit {
  public SpeakerBrands = DeviceModel.SpeakerBrands;
  public editLocationFormGroup: UntypedFormGroup;
  public speakers: DeviceModel.LocationDeviceDocument[];
  public query: string;

  @Input() displayedColumns = ['name', 'ipAddress', 'model', 'actions'];

  constructor(
    private store$: Store,
    private router: Router,
    private route: ActivatedRoute,
    private utilsV2: UtilsV2Service,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.store$.dispatch(
      MenuActions.setActiveLevel2Menu({
        activeLevel2: MenuKey.speakers,
      }),
    );

    this.store$.pipe(select(LocationEditSelectors.selectedLocation)).subscribe((location) => {
      if (location?.devices) {
        this.speakers = Object.values(location?.devices).filter(
          (device) => device.type === DeviceType.Speaker,
        );
      } else {
        this.speakers = [];
      }
    });
  }

  public filtered(speakers: DeviceModel.LocationDeviceDocument[]) {
    return speakers.filter((p) => p.name.toLowerCase().includes(this.query.toLowerCase()));
  }

  public edit(speaker: DeviceModel.LocationDeviceDocument) {
    this.router.navigate(['../', routerSegments.editSpeaker, speaker._id], { relativeTo: this.route });
  }

  public delete(speaker: DeviceModel.LocationDeviceDocument) {
    this.store$.dispatch(LocationEditActions.deleteSpeaker({ deviceId: speaker._id }));
  }

  public selectCamera(orig: DeviceModel.LocationDeviceDocument): void {
    const row = _.cloneDeep(orig);
    if (!row?.cameras) {
      row.cameras = {};
    }
    const cams = _.cloneDeep(row.cameras);
    const data: CameraPickerModels.CameraPickerDialogOptions = {
      options: {
        multi: true,
      },
      selectedValue: cams,
    };
    this.dialog
      .open(CameraPickerModalComponent, {
        width: '600px',
        height: '70vh',
        panelClass: 'modal-no-padding',
        disableClose: true,
        data,
      })
      .afterClosed()
      .subscribe((selectedCameras: Dictionary<CameraPickerModels.SelectedCamera>) => {
        if (selectedCameras) {
          row.cameras = selectedCameras;
          this.store$.dispatch(LocationEditActions.setSelectedSpeaker({ selectedSpeaker: row }));
          this.store$.dispatch(LocationEditActions.addSpeaker());
        }
      });
  }

  public search(query: string) {
    this.query = query;
  }
}
